<template lang="pug">
.before-update-container
  .before-update
    .top-business-line
      .left-business {{biz}}
      .right-business {{afterBiz}}
    .middle-times-line
      .left-times
        .left-times-top 剩余{{times}}{{unit}}
        .left-times-bottom {{beforeCardInfo.name}}
      .middle-times +{{countTime}}{{unit}}
      .right-times
        .right-times-top
          span 剩余
          span.big-word {{afterTime}}
          span {{afterUnit}}
        .right-times-bottom 升级为{{afterCardInfo.name}}
    .middle-word {{upgradeCardInfo}}
    .btn(@click="open")
    .time(v-if="dataObj.show")
      span 活动在
      div.haveBg {{ dataObj.hours }}
      span.gc :
      span.haveBg {{ dataObj.minutes }}
      span.gc :
      span.haveBg {{ dataObj.seconds }}
      span.gc :
      span.haveBigBg {{ dataObj.milliseconds }}
      span 后结束
  updateDialog(:show.sync="showDialog"
  :userNewId="userNewId"
  :businessId="businessId"
  :beforeUserCardId="beforeUserCardId"
  :activeId="activeId"
  @reload="reload"
  @updateError="updateError")
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getCountdown } from '@/utils/date';
import updateDialog from './updateDialog.vue';


export default {
  components: {
    updateDialog,
  },
  props: {
    beforeCardInfo: {
      type: Object,
      default: null,
    },
    afterCardInfo: {
      type: Object,
      default: null,
    },
    upgradeCardInfo: {
      type: String,
      default: '',
    },
    countDown: {
      type: Number,
      default: 0,
    },
    userNewId: {
      type: Number,
      default: 0,
    },
    businessId: {
      type: Number,
      default: 0,
    },
    beforeUserCardId: {
      type: String,
      required: true,
    },
    activeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDialog: false,
      dataObj: {
        days: '',
        hours: '',
        minutes: '',
        seconds: '',
        milliseconds: '',
        show: true,
        timer: null,
      },
    };
  },
  computed: {
    biz() {
      return this.beforeCardInfo.businessId === 1 ? '单车' : '助力车';
    },
    afterBiz() {
      return this.afterCardInfo.businessId === 1 ? '单车' : '助力车';
    },
    unit() {
      return this.beforeCardInfo.limitTime ? '次' : '天';
    },
    afterUnit() {
      return this.afterCardInfo.limitTime ? '次' : '天';
    },
    times() {
      return this.beforeCardInfo.limitTime
        ? this.beforeCardInfo.remainCardTimes : this.beforeCardInfo.remainDay;
    },
    afterTime() {
      return this.afterCardInfo.limitTime
        ? this.afterCardInfo.remainCardTimes : this.afterCardInfo.remainDay;
    },
    countTime() {
      return this.afterTime - this.times;
    },
  },
  mounted() {
    this.timer = setInterval(
      () => this.updateCountdown(),
      100,
    );
  },
  beforeDestroy() {
    this.timer = null;
  },
  methods: {
    open() {
      this.showDialog = true;
      UBT.clickButton({
        pageId: 'platform_cardupdate_trans',
        buttonName: 'platform_cardupdate_button',
        categoryId: 'platform',
        businessInfo: {
          bizType: this.businessId - 1,
        },
      });
      UBT.moduleExpose({
        pageId: 'platform_cardupdate_trans',
        categoryId: 'platform',
        moduleId: 'platform_cardupdate_confirm',
        contentId: 'platform_cardupdate_confirm',
        exposureTimes: 1,
        businessInfo: {
          bizType: this.businessId - 1,
        },
      });
    },
    updateCountdown() {
      this.dataObj = getCountdown(this.countDown);
    },
    reload() {
      this.$emit('reload');
    },
    updateError() {
      this.$emit('updateError');
    },
  },
};
</script>
<style lang="less" scoped>
.before-update-container {
  .before-update {
    padding-top: 1.58rem;

    .top-business-line {
      display: flex;
      justify-content: space-between;
      margin: 0 0.28rem 0 0.36rem;

      .left-business {
        width: 50%;
        text-align: center;
        color: #e2f3ff;
        font-family: Inter, sans-serif;
        font-size: 0.11rem;
        font-weight: 400;
        line-height: 0.13rem;
        margin-top: 0.29rem;
        margin-left: 0.02rem;
      }

      .right-business {
        width: 60%;
        text-align: center;
        color: #e2f3ff;
        font-family: Inter, sans-serif;
        font-size: 0.11rem;
        font-weight: 400;
        line-height: 0.13rem;
      }
    }

    .middle-times-line {
      display: flex;
      justify-content: space-between;
      margin: 0 0.5rem 0 0.7rem;

      .middle-times {
        margin-left: -0.28rem;
        font-family: Alibaba PuHuiTi, sans-serif;
        font-size: 0.16rem;
        font-weight: 700;
        line-height: 0.22rem;
        color: #fff;
      }

      .left-times {
        margin-top: 0.3rem;
        width: 0.84rem;
        text-align: center;

        .left-times-top {
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.18rem;
          font-weight: 700;
          line-height: 0.247rem;
          color: #47a7ff;
        }

        .left-times-bottom {
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          line-height: 0.164rem;
          color: #86cafe;
          margin-top: 0.06rem;
        }
      }

      .right-times {
        margin-top: 0.1rem;

        .right-times-top {
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.24rem;
          font-weight: 900;
          line-height: 0.33rem;
          color: #fff;

          span.big-word {
            font-size: 0.46rem;
          }
        }

        .right-times-bottom {
          margin-top: 0.08rem;
          font-family: Alibaba PuHuiTi, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          color: #fff;
        }
      }
    }

    .middle-word {
      margin-top: 0.35rem;
      font-family: Alibaba PuHuiTi, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      line-height: 0.15rem;
      text-align: center;
      color: #acab9c;
    }

    .btn {
      margin: 0.03rem auto 0 auto;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/oRBYtH0fJy.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      width: 3.24rem;
      height: 0.65rem;
    }

    .time {
      display: flex;
      justify-content: center;
      font-family: Alibaba PuHuiTi, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      line-height: 0.15rem;
      color: #acab9c;

      .haveBg {
        color: #693900;
        background: #d8d7c3;
        border-radius: 0.02rem;
        padding: 0 0.01rem;
        width: 0.15rem;
        height: 0.15rem;
        text-align: center;
      }

      .haveBigBg {
        width: 0.23rem;
        height: 0.15rem;
        border-radius: 0.02rem;
        color: #693900;
        background: #d8d7c3;
        text-align: center;
      }

      .gc {
        color: #693900;
      }
    }
  }
}
</style>
